import { render, staticRenderFns } from "./ReceiptVerification.html?vue&type=template&id=6f0f7d36&external"
import script from "./ReceiptVerification.js?vue&type=script&lang=js&external"
export * from "./ReceiptVerification.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports